import { useQuery } from '@tanstack/react-query';
import { getCounties, getStates, type USCounty, type USState } from '@/shared/api/geographyApi';

export function useSharedStates() {
  return useQuery<USState[], Error>({
    queryKey: ['geography', 'states'],
    queryFn: () => getStates(),
    staleTime: 1000 * 60 * 60,
    retry: false,
  });
}

export function useSharedCounties(stateCode?: string, enabled = true) {
  return useQuery<USCounty[], Error>({
    queryKey: ['geography', 'counties', stateCode],
    queryFn: () => getCounties(stateCode),
    staleTime: 1000 * 60 * 60,
    enabled: Boolean(stateCode) && enabled,
    retry: false,
  });
}
